export default __webpack_public_path__ + "static/media/Thumb_Top_03.b11d115f.png";